import { createSelector } from 'reselect'
import has from 'lodash/has'
import mapValues from 'lodash/mapValues'
import { selectHighestRateLoanDictionary } from './home/dictionary'
import { selectCorporateProfile } from './customerProfile'

export const selectSettingsMap = state => mapValues(state.airDna, 'settings')

export const selectParamsMap = state => mapValues(state.airDna, 'params')

/*
 * Represents a given set of airdna data for a component's stateKey
 */
const getPropertyDetails = ({ data = {}, settings }) => {
  if (!data.stats?.future?.summary) {
    return {}
  }

  const { adr, revenue, occupancy } = data.stats?.future?.summary
  const { nightsPerMonth, pricePerNight } = settings
  const paymentMax = adr
  const rentalNightMax = occupancy * 30

  const monthlyOccupancy = nightsPerMonth ? parseFloat(parseInt(nightsPerMonth, 10) / rentalNightMax) : 1
  const nightlyRate = pricePerNight ? parseFloat(parseInt(pricePerNight, 10) / paymentMax) : 1
  const monthlyRevenue = 1 * monthlyOccupancy * nightlyRate
  const annualEarnings = revenue * monthlyRevenue
  const monthlyEarnings = annualEarnings / 12

  return {
    rentalNightMax,
    monthlyRevenue,
    monthlyEarnings,
    annualEarnings,
    paymentMax
  }
}

const getPropertyDetailsMap = airDnaState => mapValues(airDnaState, getPropertyDetails)

export const selectPropertyDetailsMap = createSelector(state => state.airDna, getPropertyDetailsMap)

export const selectHasRequestDataMap = createSelector(
  state => state.airDna,
  airDna => mapValues(airDna, branch => has(branch, 'data.stats'))
)

export const selectShouldShowAirDnaModule = createSelector(
  selectCorporateProfile,
  profile => profile && profile.showNightlyRentals
)
